import { render, staticRenderFns } from "./FileStatusChip.vue?vue&type=template&id=e14ec53a"
import script from "./FileStatusChip.vue?vue&type=script&lang=ts"
export * from "./FileStatusChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports